/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Constructor ${i?.number}`)
};

const es_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Constructor ${i?.number}`)
};

const de_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konstrukteur ${i?.number}`)
};

const nl_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Constructeur ${i?.number}`)
};

const fr_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Constructeur ${i?.number}`)
};

const it_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Costruttore ${i?.number}`)
};

const pt_br2_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Construtor ${i?.number}`)
};

const pt_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Construtor ${i?.number}`)
};

const ja_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`コンストラクター ${i?.number}`)
};

const zh_f1_team_selector_constructor_slot = /** @type {(inputs: { number: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`车队${i?.number}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ number: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_team_selector_constructor_slot = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_team_selector_constructor_slot(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_team_selector_constructor_slot", locale)
	if (locale === "en") return en_f1_team_selector_constructor_slot(inputs)
	if (locale === "es") return es_f1_team_selector_constructor_slot(inputs)
	if (locale === "de") return de_f1_team_selector_constructor_slot(inputs)
	if (locale === "nl") return nl_f1_team_selector_constructor_slot(inputs)
	if (locale === "fr") return fr_f1_team_selector_constructor_slot(inputs)
	if (locale === "it") return it_f1_team_selector_constructor_slot(inputs)
	if (locale === "pt-BR") return pt_br2_f1_team_selector_constructor_slot(inputs)
	if (locale === "pt") return pt_f1_team_selector_constructor_slot(inputs)
	if (locale === "ja") return ja_f1_team_selector_constructor_slot(inputs)
	return zh_f1_team_selector_constructor_slot(inputs)
};